import React, { useEffect, useState } from 'react';
import styles from './../../Assets/CSS/Register.module.css';
import inputStyles from './../../Assets/CSS/Input.module.css';
import axios from 'axios';
import { BASE_URL, BASE_PAYMENT_URL } from './../../Environment'; 
import { useNavigate } from 'react-router-dom';
import { BlueButton } from './../../Components/Button';
import { toast } from 'react-toastify'; 
import { BsYoutube } from 'react-icons/bs'; 
 
function Register() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [whatsapp, setWhatsapp] = useState('');
    const [dob, setDoB] = useState('');
    const [gender, setGender] = useState('');
    const [education, setEducation] = useState('');
    const [blood_group, setBloodGroup] = useState(''); 
    const [pincode, setPincode] = useState('');
    const [house_no, setHouseNo] = useState('');
    const [road_name, setRoadName] = useState(''); 
    const [district, setDistrict] = useState('');
    const [state, setState] = useState('');
    const [country, setCountry] = useState(''); 
    const [landmark, setLandmark] = useState(''); 
    const [aadhaar_no, setAadhaarNo] = useState('');
    const [pan_no, setPanNo] = useState(''); 
    const [nominee_name, setNomineeName] = useState('');
    const [nominee_relation, setNomineeRelation] = useState('');
    const [nominee_address, setNomineeAddress] = useState('');
    const [nominee_mobile, setNomineeMobile] = useState('');
    const [nominee_aadhaar_no, setNomineeAadhaarNo] = useState('');
    const [nominee_pan_no, setNomineePanNo] = useState(''); 
    const [password, setPassword] = useState('');
    const [confirm_password, setConfirmPassword] = useState('');
    const [referral_code, setReferralCode] = useState('');
    const [referralInfo, setReferralInfo] = useState(null);
    const [isCheckingReferral, setIsCheckingReferral] = useState(false);

    useEffect(() => {
        document.title = 'Infomart | Agent Register';
    }, []);

    useEffect(() => {
        if (referral_code && referral_code.length >= 6) {
            checkReferralCode(referral_code);
        } else {
            setReferralInfo(null);
        }
    }, [referral_code]);

    const checkReferralCode = async (code) => {
        if (!code.trim()) { setReferralInfo(null); return; }
        setIsCheckingReferral(true);
        try {
            const res = await axios.get(`${BASE_URL}/check-referral/${code}`);
            if (res.data.success && res.data.type === 'employee') {
                setReferralInfo({ exists: true, name: res.data.name, type: res.data.type, id: res.data.id, code: res.data.code, designation: res.data.designation });
            } else if (res.data.success && res.data.type === 'agent') {
                setReferralInfo({ exists: false, invalidType: true });
            } else {
                setReferralInfo({ exists: false });
            }
        } catch (error) {
            setReferralInfo({ exists: false });
        }
        finally { setIsCheckingReferral(false); }
    };

    const handleReferralCodeChange = (e) => {
        const value = e.target.value.toUpperCase();
        setReferralCode(value);
    };

    const handleRegister = async () => {
        setIsLoading(true);
        if (password === confirm_password) {
            await axios.post(`${BASE_URL}/agent/register`, { 
                name, email, phone, whatsapp, dob, gender, education, blood_group, 
                house_no, road_name, pincode, district, state, country, landmark, 
                aadhaar_no, pan_no, nominee_name, nominee_relation, nominee_address, 
                nominee_mobile, nominee_aadhaar_no, nominee_pan_no, password,
                employee_id: referralInfo?.exists && referralInfo?.type === 'employee' ? referralInfo.id : null
            }, {
                headers: {     
                    'Content-Type': 'application/json'
                } 
            }).then((res) => { 
                toast.success(res.data.msg, { autoClose: 3000 });
                setIsLoading(false);
                const id = res.data.id;  
                axios.post(`${BASE_URL}/agent/payment`, { id }, {
                    headers: {       
                        'Content-Type': 'application/json' 
                    } 
                }).then((res) => {  
                    if (res.data.encrypted_data && res.data.access_code) { 
                        const form = document.createElement('form');
                        form.method = 'post';
                        form.action = BASE_PAYMENT_URL;   
                        const encRequestInput = document.createElement('input');
                        encRequestInput.type = 'hidden';
                        encRequestInput.name = 'encRequest';
                        encRequestInput.id = 'encRequest';
                        encRequestInput.value = res.data.encrypted_data;
                        form.appendChild(encRequestInput); 
                        const accessCodeInput = document.createElement('input');
                        accessCodeInput.type = 'hidden';
                        accessCodeInput.name = 'access_code';
                        accessCodeInput.id = 'access_code';
                        accessCodeInput.value = res.data.access_code;
                        form.appendChild(accessCodeInput); 
                        document.body.appendChild(form); 
                        form.submit(); 
                    }    
                }).catch((res) => {  
                    toast.error(res.response.data.msg, { autoClose: 3000 }); 
                });   
            }).catch((res) => {
                toast.error(res.response.data.msg, { autoClose: 3000 });
                setIsLoading(false);
            });
        } else {
            toast.error('Password and Confirm Password does not match.', { autoClose: 3000 });
            setIsLoading(false);
        }
    } 
    const handleDateChange = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, '');
        if (value.length > 8) {
            value = value.substring(0, 8);
        }
        if (value.length >= 5) {
            value = value.replace(/^(\d{2})(\d{2})(\d{0,4})$/, '$1/$2/$3');
        } else if (value.length >= 3) {
            value = value.replace(/^(\d{2})(\d{0,2})$/, '$1/$2');
        }
        setDoB(value);
    };
    const handlePincode = (e) => {
        let value = e.target.value;
        setPincode(value); 
        if (value.length == 6) {
            axios.get(`${BASE_URL}/pincode/${value}`).then((res) => { 
                setDistrict(res.data[0].PostOffice[0].District);
                setState(res.data[0].PostOffice[0].State);
                setCountry(res.data[0].PostOffice[0].Country); 
            });    
        }
    }  
    return (
        <div className="app">
            <div className="outlet">
                <div className={styles.individualFormContainer}>
                    <div className={styles.top}> 
                        <div className="w-100">
                            <h4 className="text-left my-3" style={{whiteSpace:'nowrap'}}>Agent Register</h4>
                            <a href="https://www.youtube.com/watch?v=SSSa8BKdl1M" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 13, color: 'red', textDecoration: 'none', marginBottom: 10 }}>
                                <BsYoutube size={18} /> Watch Form Fill-up Tutorial
                            </a> 
                        </div> 
                    </div>
                    <div id="input-city-a" className={styles.row}>
                        <div style={{ position: 'relative', width: '100%' }}>
                            <input type="text" className={inputStyles.input} placeholder="Enter Employee Referral Code (Optional)" value={referral_code} onChange={handleReferralCodeChange} />
                            {(isCheckingReferral || referralInfo) && (
                                <div style={{
                                    marginTop: '8px', padding: '8px 12px', borderRadius: '4px', fontSize: '14px',
                                    display: 'flex', alignItems: 'center', gap: '8px',
                                    backgroundColor: isCheckingReferral ? '#f8f9fa' : referralInfo?.exists ? '#d4edda' : '#f8d7da',
                                    border: `1px solid ${isCheckingReferral ? '#dee2e6' : referralInfo?.exists ? '#c3e6cb' : '#f5c6cb'}`,
                                    color: isCheckingReferral ? '#6c757d' : referralInfo?.exists ? '#155724' : '#721c24'
                                }}>
                                    {isCheckingReferral ? (
                                        <>
                                            <div style={{ width: '16px', height: '16px', border: '2px solid #6c757d', borderTop: '2px solid transparent', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
                                            Checking referral code...
                                        </>
                                    ) : referralInfo?.exists ? (
                                        <>
                                            <span style={{ color: '#28a745', fontWeight: 'bold' }}>✓</span>
                                            {referralInfo.type} found: <strong>{referralInfo.name}</strong> {referralInfo.designation && `- ${referralInfo.designation}`}
                                        </>
                                    ) : (
                                        <>
                                            <span style={{ color: '#dc3545', fontWeight: 'bold' }}>✗</span>
                                            {referralInfo?.invalidType ? 'Agent referral not allowed. Only Employee (SE/SM) codes accepted.' : 'Invalid referral code'}
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                    <div id="not-row-a" className={styles.row}>
                        <input type="text" className={inputStyles.input} placeholder="Enter Your Full Name *" onChange={e => setName(e.target.value)} />
                        <input type="email" className={inputStyles.input} placeholder="Enter Email ID *" onChange={e => setEmail(e.target.value)} />
                    </div>
                    <div id="not-row-a" className={styles.row}>
                        <input type="number" className={inputStyles.input} placeholder="Enter Phone No. *" onChange={e => setPhone(e.target.value)} />
                        <input type="number" className={inputStyles.input} placeholder="Enter WhatsApp No. *" onChange={e => setWhatsapp(e.target.value)} />
                    </div>
                    <div id="not-row-a" className={styles.row}>
                        <input type="text" className={inputStyles.input} value={dob} placeholder="Enter Date of Birth (DD/MM/YYYY) *" onChange={handleDateChange} /> 
                        <select className={inputStyles.dropdown} onChange={e => setGender(e.target.value)}> 
                            <option value="" selected disabled>Select Gender *</option>
                            <option value="Male">Male</option> 
                            <option value="Female">Female</option>
                        </select> 
                    </div>
                    <div id="not-row-a" className={styles.row}>
                        <input type="text" className={inputStyles.input} placeholder="Enter Education *" onChange={e => setEducation(e.target.value)} /> 
                        <select className={inputStyles.dropdown} onChange={e => setBloodGroup(e.target.value)}>  
                            <option value="" selected disabled>Select Blood Group</option>
                            <option value="A+">A+</option> 
                            <option value="A-">A-</option>
                            <option value="B+">B+</option>
                            <option value="B-">B-</option>
                            <option value="AB+">AB+</option>
                            <option value="AB-">AB-</option>
                            <option value="O+">O+</option>
                            <option value="O-">O-</option> 
                        </select> 
                    </div>   
                    <div id="not-row-b" className={styles.row}> 
                        <input type="text" className={inputStyles.input} placeholder="Enter House No." onChange={e => setHouseNo(e.target.value)} />
                        <input type="text" className={inputStyles.input} placeholder="Enter Road Name *" onChange={e => setRoadName(e.target.value)} />
                    </div>  
                    <div id="not-row-b" className={styles.row}>
                        <input type="number" className={inputStyles.input} placeholder="Enter Pincode *" onChange={handlePincode} />  
                        <input type="text" className={inputStyles.input} value={district} placeholder="Enter District *" onChange={e => setDistrict(e.target.value)} />
                        <input type="text" className={inputStyles.input} value={state} placeholder="Enter State *" onChange={e => setState(e.target.value)} />
                    </div> 
                    <div id="not-row-b" className={styles.row}>
                        <input type="text" className={inputStyles.input} value={country} placeholder="Enter Country *" onChange={e => setCountry(e.target.value)} />
                    
                    </div>  
                     <textarea className={inputStyles.input} placeholder="Enter Landmark (Optional)" onChange={e => setLandmark(e.target.value)} />  
                        <input type="number" className={inputStyles.input} placeholder="Enter Aadhaar No. *" onChange={e => setAadhaarNo(e.target.value)} />
                        <>
                            <input type="text" className={inputStyles.input} placeholder="Enter Pan No. *" onChange={e => setPanNo(e.target.value.toUpperCase())} style={{ textTransform: 'uppercase' }} />
                            <style>
                                {`
                                    input::placeholder {
                                        text-transform: none;
                                    } 
                                `}  
                            </style>
                        </> 

                    <h6 className="mt-3 mb-2" style={{ fontWeight: '600', color: '#333' }}>Nominee Details (Optional)</h6>
                    <div id="input-city-a" className={styles.row}>
                        <input type="text" className={inputStyles.input} placeholder="Nominee Name" onChange={e => setNomineeName(e.target.value)} />
                        <select className={inputStyles.dropdown} onChange={e => setNomineeRelation(e.target.value)}>
                            <option value="" disabled selected>Select Relation</option>
                            <option value="Father">Father</option>
                            <option value="Mother">Mother</option>
                            <option value="Spouse">Spouse</option>
                            <option value="Son">Son</option>
                            <option value="Daughter">Daughter</option>
                            <option value="Brother">Brother</option>
                            <option value="Sister">Sister</option>
                            <option value="Other">Other</option>
                        </select>
                        <input type="number" className={inputStyles.input} placeholder="Nominee Mobile No." onChange={e => setNomineeMobile(e.target.value)} />
                    </div>
                    <textarea className={inputStyles.input} placeholder="Nominee Address" onChange={e => setNomineeAddress(e.target.value)} />
                    <div id="input-city-a" className={styles.row}>
                        <input type="number" className={inputStyles.input} placeholder="Nominee Aadhaar No." onChange={e => setNomineeAadhaarNo(e.target.value)} />
                        <input type="text" className={inputStyles.input} placeholder="Nominee PAN No." onChange={e => setNomineePanNo(e.target.value.toUpperCase())} style={{ textTransform: 'uppercase' }} />
                    </div> 
                   
                    <div id="not-row-a" className={styles.row}>   
                        <input type="password" className={inputStyles.input} placeholder="Enter Password *" onChange={e => setPassword(e.target.value)} />
                        <input type="password" className={inputStyles.input} placeholder="Enter Confirm Password *" onChange={e => setConfirmPassword(e.target.value)} />
                    </div> 
                    <div className={styles.checkboxSection}>
                        <input type="checkbox" className={styles.checkbox} checked />
                        <div>
                            Agree&nbsp;
                            <span className={styles.colorTxt}>
                                <a href="/terms-conditions" target="_blank">Terms & Conditions</a> 
                            </span> 
                        </div>
                    </div>
                    <div className="mt-5">
                        <BlueButton title={isLoading ? "Loading..." : "Register"} onClick={() => handleRegister()} />
                    </div>
                </div>
            </div> 
        </div>
    );
}

export default Register; 